import { Box, Spacer, Stack, Text } from '@chakra-ui/react'
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import UserQ from '@/queries/UserQ'
import type { Query } from '@/client/query'

import PublicImage from '@/components/PublicImage/PublicImage'
import ShwLink from '@/components/ShwLink'

import ProfileItemContainer from './ProfileItemContainer'

export default function ProfileAopsUsername({ user }: { user: Query }): React.ReactElement | null {
  const aopsUsername = user`${UserQ.internal_state}->'aops'->>'username'`
  const aopsUsernamePublic = user`${UserQ.internal_state}->'aops'->>'username'`
  return aopsUsername == null || aopsUsernamePublic === false ? null : (
    <Box>
      <ShwLink width="100%" href={`https://artofproblemsolving.com/community/user/${aopsUsername}`}>
        <ProfileItemContainer>
          <Stack direction="row" spacing="16px" align="center">
            <PublicImage src="/aops_logo.png" width="48px" height="48px" />
            <Box>
              <Text variant="eyebrow" mb={2}>
                AoPS Profile
              </Text>
              <Text fontWeight={600}>{aopsUsername}</Text>
            </Box>
            <Spacer />
            <Text color="fg.subtle">
              <FontAwesomeIcon icon={faChevronRight} />
            </Text>
          </Stack>
        </ProfileItemContainer>
      </ShwLink>
    </Box>
  )
}
